import { html, customElement } from '@adobe/edex/ui/edex-lit';
import styles from '@adobe/edex/ui/components/shared/card/card.lit.scss';
import { EdexDomID, EdexTagName } from '@adobe/edex/ui/shared/constants';
import { classMap } from '@adobe/edex/ui/edex-lit';
import { $t } from '@adobe/edex/ui/shared/config/i18n';
import { I18nKey } from '@adobe/edex/ui/shared/constants/i18n';
import { styleMap } from '@adobe/edex/ui/edex-lit';
import { BaseElement } from '@adobe/edex/ui/components/base.element';

const MAX_COLLAPSED_HEIGHT_PX = 180;

@customElement(EdexTagName.card)
export class Card extends BaseElement {
  static styles = styles;
  static get properties() {
    return {
      title: { type: String },
      isCollapsible: { type: Boolean },
      isCollapsed: { type: Boolean },
    };
  }
  title: string;
  isCollapsible: boolean;
  isCollapsed = false;

  get collapsedStyle() {
    return styleMap({
      'max-height': this.isCollapsed ? `${MAX_COLLAPSED_HEIGHT_PX}px` : 'none',
    });
  }

  firstUpdated() {
    setTimeout(this.calculateIsCollapsed);
  }

  calculateIsCollapsed = () => {
    if (!this.isCollapsible) {
      return;
    }
    const { clientHeight } = this.shadowRoot.querySelector('.card-content');
    this.isCollapsible = clientHeight > MAX_COLLAPSED_HEIGHT_PX;
    this.isCollapsed = this.isCollapsible;
  };

  render() {
    const { title, isCollapsed, isCollapsible, collapsedStyle } = this;
    return html`
      <sp-card class="card">
        <h2 class="card-title" slot="heading">${title}</h2>
        <div slot="footer">
          <div class="card-content ${classMap({ collapsed: isCollapsed })}" style="${collapsedStyle}">
            <slot name="content"></slot>
          </div>
          ${isCollapsible
            ? html`
                <sp-link
                  id=${EdexDomID.viewMore}
                  quiet
                  variant="primary"
                  @click=${() => (this.isCollapsed = !this.isCollapsed)}
                >
                  ${isCollapsed ? $t(I18nKey.viewMore) : $t(I18nKey.viewLess)}
                </sp-link>
              `
            : ''}
        </div>
      </sp-card>
    `;
  }
}
